/**
 * @generated SignedSource<<99cc68858aad929e8d1512c21bff87d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostIdType = "DATABASE_ID" | "ID" | "SLUG" | "URI";
export type ZnglyPostTypeEnum = "Catalog" | "Category" | "CrmList" | "Form" | "FormEntry" | "Hub" | "HubPage" | "MediaItem" | "SiteSettings" | "User" | "Znglist";
export type RequestPostAccessInput = {
  clientMutationId?: string | null | undefined;
  code?: string | null | undefined;
  email?: string | null | undefined;
  id?: string | null | undefined;
  idType?: PostIdType | null | undefined;
  postType?: ZnglyPostTypeEnum | null | undefined;
  zncid?: string | null | undefined;
};
export type Utils_RequestPostAccess_Mutation$variables = {
  input: RequestPostAccessInput;
};
export type Utils_RequestPostAccess_Mutation$data = {
  readonly requestPostAccess: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type Utils_RequestPostAccess_Mutation = {
  response: Utils_RequestPostAccess_Mutation$data;
  variables: Utils_RequestPostAccess_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestPostAccessPayload",
    "kind": "LinkedField",
    "name": "requestPostAccess",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Utils_RequestPostAccess_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Utils_RequestPostAccess_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "424a1199ae64be47b0ea0cddfb5f9861",
    "id": null,
    "metadata": {},
    "name": "Utils_RequestPostAccess_Mutation",
    "operationKind": "mutation",
    "text": "mutation Utils_RequestPostAccess_Mutation(\n  $input: RequestPostAccessInput!\n) {\n  requestPostAccess(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e6a6d2d78ff14519cc57ff1f9db674a8";

export default node;
